import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const TwoFourFiveToTwoSevenFour = () => {
  return (
    <Table>
      <Tbody>
        <tr>
          <Td>245</Td>
          <Td>
            เพลง
            <br />
            ซาโลมอน 7,8
          </Td>
          <Td>สดุดี 99-101</Td>
          <Td>Song of songs 7,8</Td>
          <Td>
            Psalms <br />
            99-101
          </Td>

          <Td>เพลินใจในรัก</Td>
        </tr>
        <tr>
          <Td>246</Td>
          <Td>อิสยาห์ 1,2</Td>
          <Td>1 ทิโมธี 6</Td>
          <Td>Isaiah 1,2</Td>
          <Td>1 Timothy 6</Td>

          <Td>บุตรของพระเจ้า</Td>
        </tr>
        <tr>
          <Td>247</Td>
          <Td>อิสยาห์ 3-5</Td>
          <Td>2 ทิโมธี 1</Td>
          <Td>Isaiah 3-5</Td>
          <Td>2 Timothy 1</Td>

          <Td>มีแต่เรื่องเศร้าหรือ?</Td>
        </tr>
        <tr>
          <Td>248</Td>
          <Td>อิสยาห์ 6,7</Td>
          <Td>2 ทิโมธี 2</Td>
          <Td>Isaiah 6,7</Td>
          <Td>2 Timothy 2</Td>

          <Td>สารแห่งความจริง</Td>
        </tr>
        <tr>
          <Td>249</Td>
          <Td>อิสยาห์ 8,9</Td>
          <Td>สดุดี 102</Td>
          <Td>Isaiah 8,9</Td>
          <Td>Psalms 102</Td>

          <Td>ในยามยากลำบาก</Td>
        </tr>
        <tr>
          <Td>250</Td>
          <Td>อิสยาห์ 10-12</Td>
          <Td>2 ทิโมธี 3</Td>
          <Td>Isaiah 10-12</Td>
          <Td>2 Timothy 3</Td>

          <Td>แผนการช่วยกู้</Td>
        </tr>
        <tr>
          <Td>251</Td>
          <Td>อิสยาห์ 13,14</Td>
          <Td>2 ทิโมธี 4</Td>
          <Td>Isaiah 13,14</Td>
          <Td>2 Timothy 4</Td>

          <Td>มาชุมนุมกัน</Td>
        </tr>
        <tr>
          <Td>252</Td>
          <Td>
            อิสยาห์ <br />
            15,16
          </Td>
          <Td>สดุดี 103</Td>
          <Td>Isaiah 15,16</Td>
          <Td>Psalms 103</Td>

          <Td>กษัตริย์ผู้ทรงยุติธรรม</Td>
        </tr>
        <tr>
          <Td>253</Td>
          <Td>
            อิสยาห์ <br />
            17-20
          </Td>
          <Td>ทิตัส 1</Td>
          <Td>Isaiah 17,20</Td>
          <Td>Titus 1</Td>

          <Td>เป็นเรื่องที่จริงจัง</Td>
        </tr>
        <tr>
          <Td>254</Td>
          <Td>อิสยาห์ 21,22</Td>
          <Td>ทิตัส 2</Td>
          <Td>Isaiah 21,22</Td>
          <Td>Titus 2</Td>

          <Td>จงฟังพระเจ้า</Td>
        </tr>
        <tr>
          <Td>255</Td>
          <Td>อิสยาห์ 23,24</Td>
          <Td>ทิตัส 3</Td>
          <Td>Isaiah 23,24</Td>
          <Td>Titus 3</Td>

          <Td>ต้องการพระผู้ช่วยให้รอด</Td>
        </tr>
        <tr>
          <Td>256</Td>
          <Td>อิสยาห์ 25,26</Td>
          <Td>สดุดี 104</Td>
          <Td>Isaiah 25,26</Td>
          <Td>Psalms 104</Td>

          <Td>รากฐานมั่นคง</Td>
        </tr>
        <tr>
          <Td>257</Td>
          <Td>อิสยาห์ 27,28</Td>
          <Td>ฟิเลโมน</Td>
          <Td>Isaiah 27,28</Td>
          <Td>Philemon</Td>

          <Td>เฝ้าระวังไว้</Td>
        </tr>
        <tr>
          <Td>258</Td>
          <Td>อิสยาห์ 29,30</Td>
          <Td>ฮีบรู 1</Td>
          <Td>Isaiah 29,30</Td>
          <Td>Hebrew 1</Td>

          <Td>พระเจ้าตรัส</Td>
        </tr>
        <tr>
          <Td>259</Td>
          <Td>อิสยาห์ 31,32</Td>
          <Td>สดุดี 105</Td>
          <Td>Isaiah 31,32</Td>
          <Td>Psalm 105</Td>

          <Td>ระลึกถึงและขอบพระคุณ</Td>
        </tr>
        <tr>
          <Td>260</Td>
          <Td>อิสยาห์ 33,34</Td>
          <Td>ฮีบรู 2</Td>
          <Td>Isaiah 33,34</Td>
          <Td>Hebrew 2</Td>

          <Td>ป่าวประกาศแก่ประชาชาติ</Td>
        </tr>
        <tr>
          <Td>261</Td>
          <Td>อิสยาห์ 35,36</Td>
          <Td>ฮีบรู 3</Td>
          <Td>Isaiah 35,36</Td>
          <Td>Hebrew 3</Td>

          <Td>พระองค์ทรงยิ่งใหญ่สูงสุด</Td>
        </tr>
        <tr>
          <Td>262</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.37.THSV11">
              อิสยาห์ 37,38
            </a>
          </Td>
          <Td>ฮีบรู 4</Td>
          <Td>Isaiah 37,38</Td>
          <Td>Hebrew 4</Td>

          <Td>สัญญา สัญญา</Td>
        </tr>
        <tr>
          <Td>263</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.39.THSV11">
              อิสยาห์ 39,40
            </a>
          </Td>
          <Td>สดุดี 106</Td>
          <Td>Isaiah 39,40</Td>
          <Td>Psalms 106</Td>

          <Td>เหนือใดเปรียบปาน</Td>
        </tr>
        <tr>
          <Td>264</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.41.THSV11">
              อิสยาห์ 41,42
            </a>
          </Td>
          <Td>ฮีบรู 5</Td>
          <Td>Isaiah 41,42</Td>
          <Td>Hebrew 5</Td>

          <Td>ผู้รับใช้และปุโรหิต</Td>
        </tr>
        <tr>
          <Td>265</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.43.THSV11">
              อิสยาห์ 43,44
            </a>
          </Td>
          <Td>ฮีบรู 6</Td>
          <Td>Isaiah 43,44</Td>
          <Td>Hebrew 6</Td>

          <Td>เดินมุ่งหน้าไป</Td>
        </tr>
        <tr>
          <Td>266</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.45.THSV11">
              อิสยาห์ 45,46
            </a>
          </Td>
          <Td>สดุดี 107</Td>
          <Td>Isaiah 45,46</Td>
          <Td>Psalms 107</Td>

          <Td>ใคร่ครวญสิ่งนี้</Td>
        </tr>
        <tr>
          <Td>267</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.47.THSV11">
              อิสยาห์ 47,48
            </a>
          </Td>
          <Td>ฮีบรู 7</Td>
          <Td>Isaiah 47,48</Td>
          <Td>Hebrew 7</Td>

          <Td>ชนชาติของพระเจ้า</Td>
        </tr>
        <tr>
          <Td>268</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.49.THSV11">
              อิสยาห์ 49,50
            </a>
          </Td>
          <Td>ฮีบรู 8</Td>
          <Td>Isaiah 49,50</Td>
          <Td>Hebrew 8</Td>

          <Td>เชื่อมความสัมพันธ์</Td>
        </tr>
        <tr>
          <Td>269</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.51.THSV11">
              อิสยาห์ 51,52
            </a>
          </Td>
          <Td>ฮีบรู 9</Td>
          <Td>Isaiah 51,52</Td>
          <Td>Hebrew 9</Td>

          <Td>รูปแบบใหม่</Td>
        </tr>
        <tr>
          <Td>270</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.53.THSV11">
              อิสยาห์ 53,54
            </a>
          </Td>
          <Td>สดุดี 108,109</Td>
          <Td>Isaiah 53,54</Td>
          <Td>Psalms 108,109</Td>

          <Td>ความรักของพระเจ้า</Td>
        </tr>
        <tr>
          <Td>271</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.55.THSV11">
              อิสยาห์ 55,56
            </a>
          </Td>
          <Td>ฮีบรู 10</Td>
          <Td>Isaiah 55,56</Td>
          <Td>Hebrew 10</Td>

          <Td>ดีเกินกว่าที่จะปฏิเสธได้</Td>
        </tr>
        <tr>
          <Td>272</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.57.THSV11">
              อิสยาห์ 57,58
            </a>
          </Td>
          <Td>ฮีบรู 11</Td>
          <Td>Isaiah 57,58</Td>
          <Td>Hebrew 11</Td>

          <Td>ความเชื่อเป็นหนทางเดียว</Td>
        </tr>
        <tr>
          <Td>273</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.59.THSV11">
              อิสยาห์ 59,60
            </a>
          </Td>
          <Td>สดุดี 110,111</Td>
          <Td>Isaiah 59,60</Td>
          <Td>Psalms 110,111</Td>

          <Td>ความสว่างนิรันดร์</Td>
        </tr>
        <tr>
          <Td>274</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/ISA.61.THSV11">
              อิสยาห์ 61,62
            </a>
          </Td>
          <Td>ฮีบรู 12</Td>
          <Td>Isaiah 61,62</Td>
          <Td>Hebrew 12</Td>

          <Td>เลือกไว้ด้วยจุดประสงค์</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default TwoFourFiveToTwoSevenFour;
